import React from "react";
import { useSelector } from "react-redux";

const Footer = () => {
    const { cmsData } = useSelector((state) => state.userDetails);

    const {privacy_policy, terms_conditions, privacy_policy_link, terms_conditions_link} = cmsData

    const getPrivacyLink = () => {
        return privacy_policy_link;
    };

    const getTermConditionLink = () => {
        return terms_conditions_link;
    };


    return (
        <div className="footer">
            <div className="footer__content">
                <a
                    draggable="false"
                    href={getPrivacyLink()}
                    className="footer__link"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {privacy_policy}
                </a>
                <span className="footer__content__line"></span>
                <a
                    draggable="false"
                    href={getTermConditionLink()}
                    className="footer__link"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {terms_conditions}
                </a>
            </div>
        </div>
    );
};

Footer.propTypes = {};

export default Footer;
